import { render } from "./BankCardsAdd.vue?vue&type=template&id=058b1a66&scoped=true"
import script from "./BankCardsAdd.vue?vue&type=script&lang=js"
export * from "./BankCardsAdd.vue?vue&type=script&lang=js"

import "./BankCardsAdd.vue?vue&type=style&index=0&id=058b1a66&lang=scss&scoped=true"

import exportComponent from "/home/mtp/ila.amt.genova.it/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058b1a66"]])

export default __exports__